import { useTranslation } from "react-i18next";

// A quiet full-screen loading state, in the Pulse coral language.
export function FullPageSpinner({ label }: { label?: string }) {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-screen place-items-center bg-paper">
      <div className="flex flex-col items-center gap-4">
        <span
          className="h-10 w-10 animate-spin rounded-full border-[3px] border-line border-t-coral"
          role="status"
          aria-label={label ?? t("common.loading")}
        />
        {label && (
          <p className="font-display text-sm font-bold text-body-soft">{label}</p>
        )}
      </div>
    </div>
  );
}
